import React, {ReactNode} from "react";
import {IconButton} from "@bounce/shared/ui";
import {IconMenu} from "bounce-ui/backoffice";
import {Drawer} from "@mui/material";

const DrawerMenu = ({children}: {children: ReactNode}) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <Drawer
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          "& .MuiDrawer-paper": {
            width: 240,
            boxSizing: "border-box",
          },
        }}
      >
        {children}
      </Drawer>
      <IconButton onClick={handleDrawerToggle} sx={{position: "absolute", top: 8, left: 8}}>
        <IconMenu />
      </IconButton>
    </>
  );
};
export default DrawerMenu;
